import type { Lattice } from "./latticeWarp";
import type { ParsedSvgElement } from "./svgUtils";

export function cloneUint32Array(buf: Uint32Array): Uint32Array {
    return new Uint32Array(buf);
}

export function cloneArray<T>(items: T[]): T[] {
    return structuredClone(items);
}

export function cloneLattice(lattice: Lattice): Lattice {
    return lattice.map((row) => row.map((p) => ({ x: p.x, y: p.y })));
}

export function cloneElements(elements: ParsedSvgElement[]): ParsedSvgElement[] {
    return elements.map((el) => ({
        ...el,
        attributes: { ...el.attributes },
    }));
}
